import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { appAxios } from '@doda/common/src/libs/axios/appAxios';
import {
  ErrorResponseBody,
  JobDetailResponse,
  ScoutJobDetailResponse,
} from '@doda/api-client/aspida/@types';

// 求人取得失敗時のエラーコード
// TODO: ErrorResponseBody['code']の型が列挙されるようになったら修正
export type GetJobDetailErrorCode =
  | 'NOT_FOUND_EXPECTED_RESOURCE' // もう一方に求人あり→新基盤にリダイレクト
  | 'EXPIRED' // 掲載終了
  | 'NOT_FOUND' // 求人なし→新基盤にリダイレクト
  | 'SYSTEM_ERROR'; // システムエラーで新基盤にリダイレクト
export type JobDetailError = ErrorResponseBody & {
  code: GetJobDetailErrorCode | undefined;
};

/**
 * 求人詳細取得処理
 */
export const getJobSearchDetailById = createAsyncThunk<
  JobDetailResponse,
  { id: string; headers? },
  {
    rejectValue: JobDetailError | undefined;
  }
>('jobSearchDetail/getById', async (opt, thunkAPI) => {
  const { id, headers } = opt;
  const url = `/api/v1/job/${id}`;
  const jobSearchDetail = await appAxios({
    url,
    headers,
  })
    .then((res: AxiosResponse<JobDetailResponse>) => {
      return res.data;
    })
    .catch((error: AxiosError<JobDetailError>) => {
      return thunkAPI.rejectWithValue(error.response?.data);
    });

  return jobSearchDetail;
});

export type GetJobSearchDetailById = ReturnType<
  ReturnType<typeof getJobSearchDetailById>
>;

/**
 * スカウト求人詳細取得処理
 */
export const getScoutJobSearchDetailById = createAsyncThunk<
  ScoutJobDetailResponse,
  { id: string; scoutId?: string; headers? },
  {
    rejectValue: JobDetailError | undefined;
  }
>('jobSearchDetail/getByScoutId', async (opt, thunkAPI) => {
  const { id, scoutId, headers } = opt;
  const url = `/api/v1/scout/job/${id}`;
  const jobSearchDetail = await appAxios({
    url,
    headers,
    params: {
      scoutId,
    },
  })
    .then((res: AxiosResponse<ScoutJobDetailResponse>) => {
      return res.data;
    })
    .catch((error: AxiosError<JobDetailError>) => {
      return thunkAPI.rejectWithValue(error.response?.data);
    });

  return jobSearchDetail;
});
